import { jsxs as l, jsx as o } from "react/jsx-runtime";
import { useState as S, Fragment as T } from "react";
import { c as b } from "../../index-Cu0xwYjD.js";
import { u as w, o as D, f as H, g as M, n as U, p as k, c as q, d as z, e as B } from "../../floating-ui.react-DxYXKqW-.js";
import { FloatingUIAlign as E } from "../../utils/enums.js";
import { propagateTestid as p, toArray as G } from "../../utils/helpers.js";
const J = "ids-tooltip-v501", K = "ids-tooltip--content-v501", e = {
  tooltip: J,
  content: K
}, L = ({
  children: m,
  className: d,
  align: a = "top",
  delay: f = 500,
  open: u = !1,
  tooltipText: g,
  "data-testid": s,
  ...v
}) => {
  const h = {
    [e.tooltip]: !0
  }, F = b(d, h), n = a === "auto", [i, y] = S(u), { refs: c, floatingStyles: x, context: t } = w({
    placement: n ? void 0 : a,
    open: i,
    onOpenChange: y,
    middleware: [D(5), n ? H() : M()]
  }), A = U(t, {
    move: !1,
    delay: { open: f, close: 500 }
  }), I = k(t), N = q(t), O = z(t, { role: "tooltip" }), { getReferenceProps: P, getFloatingProps: R } = B([
    A,
    I,
    N,
    O
  ]);
  return /* @__PURE__ */ l("div", { className: F, ...v, "data-testid": s, children: [
    /* @__PURE__ */ o(
      "div",
      {
        className: e.activator,
        "data-testid": p(s, "activator"),
        ref: c.setReference,
        ...P(),
        children: m
      }
    ),
    i && /* @__PURE__ */ o(
      "div",
      {
        className: e.content,
        style: x,
        "data-testid": p(s, "tooltip-text"),
        ref: c.setFloating,
        ...R(),
        children: G(g).map((j, r, C) => (
          // eslint-disable-next-line react/no-array-index-key -- No other unique index
          /* @__PURE__ */ l(T, { children: [
            j,
            r < C.length - 1 && /* @__PURE__ */ o("br", {})
          ] }, r)
        ))
      }
    )
  ] });
};
L.Align = E;
export {
  L as IressTooltip
};
